import { IEnvironment } from './environment.interface';
import { CMS_CONFIG_LIVE, GTM_ENV, INSURANCE_ENV, KAMELEOON_ENV, TARIFF_ENV, UC_ENV } from './shared';

export const environment: IEnvironment = {
    baseUrl: 'https://www.saferyou.de',
    preview: false,
    production: true,
    cms: CMS_CONFIG_LIVE,
    tariff: TARIFF_ENV,
    google_tag_manager: GTM_ENV,
    usercentrics: UC_ENV,
    kameleoon: KAMELEOON_ENV,
    insurance: INSURANCE_ENV,
};
